import axios from "axios";

const BASE_URL =
  "https://asia-southeast1-rentaru-2023-api.cloudfunctions.net/rentaru_2023";

// const BASE_URL =
//   "http://127.0.0.1:5002/rentaru-2023-api/asia-southeast1/rentaru_2023";

const instance = axios.create({
  baseURL: BASE_URL,
});

export const api_provider = (props) => {
  let { type, url, data, headers } = props;

  const headers_req = {
    "x-has-accesstoken": headers,
  };

  return new Promise(async function (resolve, reject) {
    try {
      let resData;
      switch (type) {
        case "GET":
          resData = await instance.get(url, {
            params: data,
            headers: headers_req,
          });
          break;
        case "POST":
          resData = await instance.post(url, data, {
            headers: headers_req,
            // params: data,
          });
          break;
        case "PUT":
          resData = await instance.put(url, data, {
            headers: headers_req,
          });
          break;
        case "DELETE":
          resData = await instance.delete(url, {
            params: data,
            headers: headers_req,
          });
          break;
        default:
          break;
      }
      resolve(resData.data);
    } catch (e) {
      console.error(e);
      throw e;
      // window.location.href = "/error";
    }
  });
};

export default api_provider;
